import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatAUD, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminArtworks() {
  const [artworks, setArtworks] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/admin/artworks").then((r) => setArtworks(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this artwork? This cannot be undone.")) return;
    try {
      await api.delete(`/admin/artworks/${id}`);
      toast.success("Deleted");
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  return (
    <div data-testid="admin-artworks">
      <div className="flex items-center justify-between mb-10">
        <div>
          <p className="eyebrow mb-3">Catalogue</p>
          <h1 className="font-serif text-5xl font-light">Artworks</h1>
        </div>
        <Link to="/admin/artworks/new" className="btn-ink" data-testid="new-artwork-button">+ New artwork</Link>
      </div>

      {loading ? (
        <p className="eyebrow text-muted-foreground">Loading…</p>
      ) : artworks.length === 0 ? (
        <div className="py-20 text-center">
          <h3 className="font-serif text-3xl italic font-light mb-4">No artworks yet.</h3>
          <Link to="/admin/artworks/new" className="btn-ink mt-4 inline-block">Add the first one</Link>
        </div>
      ) : (
        <div className="border-t border-border">
          {artworks.map((a) => (
            <div key={a.id} className="grid grid-cols-12 gap-4 items-center py-5 border-b border-border" data-testid={`admin-artwork-row-${a.id}`}>
              <div className="col-span-2 md:col-span-1 aspect-square bg-secondary">
                {a.image_url && <img src={a.image_url} alt={a.title} className="w-full h-full object-cover" />}
              </div>
              <div className="col-span-6 md:col-span-5">
                <p className="font-serif text-xl leading-tight">{a.title}</p>
                <p className="eyebrow text-muted-foreground mt-1">{a.orientation} · {a.collection_slug || "no collection"}</p>
              </div>
              <div className="col-span-2 text-sm tabular-nums hidden md:block">
                {formatAUD(a.price_a4)} / {formatAUD(a.price_a3)}
              </div>
              <div className="col-span-2 text-xs eyebrow text-muted-foreground">
                {a.published ? "Published" : "Draft"}{a.featured ? " · Featured" : ""}
              </div>
              <div className="col-span-4 md:col-span-2 flex gap-4 justify-end text-sm">
                <Link to={`/admin/artworks/${a.id}`} className="hair-link" data-testid={`edit-artwork-${a.id}`}>Edit</Link>
                <button onClick={() => del(a.id)} className="hair-link text-destructive" data-testid={`delete-artwork-${a.id}`}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
